<template>
  <div>
    <div class="noticia" :style="estiloFundoNoticia" @click="$emit('click')">
      <div>
        <p :style="estiloTitulo">{{ item.titulo }}</p>
        <div class="detalhes">
          <span class="formato" v-if="item.formato !== 1" :style="estiloFormato">
            <i :class="formato(item.formato).icon" v-if="item.formato !== 2"/>
            <svg-icone :url="galeriaIcone" v-if="item.formato === 2"/>
            {{ formato(item.formato).title }}
          </span>
          <span class="data">{{ formatData(item.data_publicacao) }}</span>
          <span v-for="(categoria, index) in item.categorias_nomes" :key="index">{{ categoria }}</span>
        </div>
      </div>
      <img v-if="item.foto_principal_url" :src="item.foto_principal_url"/>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import { urlIcons } from '@/utils/ImageBucket'
import { enumFormatos } from '@/views/0/Enums0'

export default {
  name: 'BigCards',
  components: {
  },
  props: {
    item: {
      type: Object
    },
    action: {
      type: Function
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo']),
    estiloFundoNoticia () {
      return {
        background: `${this.estilo.aplicacao.corPrimariaAplicacao}0d`
      }
    },
    estiloTitulo () {
      return {
        color: `${this.estilo.aplicacao.corPrimariaAplicacao}`
      }
    },
    estiloFormato () {
      return {
        background: `${this.estilo.aplicacao.corPrimariaAplicacao}`
      }
    },
    galeriaIcone () {
      return urlIcons('icon_news_gallery')
    }
  },
  methods: {
    formatData (data) {
      return moment(data, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    formato (id) {
      return enumFormatos[id]
    }
  }
}
</script>
<style lang="less">
.noticia {
  padding: 15px;
  margin-bottom: 10px;
  border-radius: 10px;
  word-wrap: break-word;
  cursor: pointer;
  display: flex;
  justify-content: space-between;

  p {
    font-size: 20px;
    line-height: 27px;
    font-weight: 600;
    margin: 0 0 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  img {
    max-width: 210px;
    max-height: 118px;
    border-radius: 10px;
    margin-left: 20px;
  }

  .detalhes .formato svg{
    width: 10px;
    height: 10px;
    margin: -2px 0;
    fill: #FFFFFF;
  }
}
</style>
